module.exports = __webpack_public_path__ + "static/media/tomato.db2a2b2d.svg";